import { KeyValue } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { ChallengesMilestoneDataService } from "src/app/core/services/challenges-milestone-data.service";
import { getdateformatService } from "src/app/core/services/get-date-format.service";
import { Globals } from "src/app/core/services/global.service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";
import { DeleteGameDialogBoxComponent } from "src/app/shared/components/dialog-box";

@Component({
  selector: "app-challenges-listing-page",
  templateUrl: "./challenges-listing-page.component.html",
  styleUrls: ["./challenges-listing-page.component.css"],
})
export class ChallengesListingPageComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private _apiCall: ApiCallService,
    public router: Router,
    private tokenStorage: TokenStorageService,
    private date_format: getdateformatService,
    private _WidgetConfigService: WidgetConfigService,
    private _snackBar: SnackbarCollection,
    private challengeService: ChallengesMilestoneDataService,
    private global:  Globals
  ) {}

  timeout;
  filter = {
    label: "",
  };
  page = 1;
  size = 10;
  selectedChallengeListPageWise = {
    1: [],
  };
  segments = [];
  tiers = [];
  customerLists = [];
  challengeList = {};
  array = {};
  tableLoading = true;
  campaignSegments = { key: "item" };
  customerCount = { key: "item" };
  isLeads = { key: "item" };
  length;
  isCustomer = { key: "item" };
  customerSegmentAndTiers = [];
  customerSegmentAndTiersMap = {};
  validWidgets;
  appSubscriptionPlan;

  sortByKeyDesc = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
    return Number(b.key) - Number(a.key); // sort keys in descending order
  }

  async ngOnInit(): Promise<void> {
    await this.getCustomerSegmentsAndTiers();
    await this.getWidgets();
  }

  async getWidgets(): Promise<void> {
    this.validWidgets = await this._WidgetConfigService.getWidget();
    this.appSubscriptionPlan =
      await this._WidgetConfigService.getAppSubscriptionPlan();
  }

  getChallengeList(label) {
    this.tableLoading = true;
    this.challengeList = [];
    this.getChallengeListApi(label).then((res) => {
      console.log(res);
      if (res) {
        this.array = res["body"]["challenges"];
        this.length = res["body"]["count"];
        for (let key in this.array) {
          let segmentIdArray = [];
          let value = this.array[key];
          let json = JSON.parse(value.audienceConfig);
          this.campaignSegments[key] = [
            ...(json?.segmentIds || []),
            ...(json?.tierIds || []),
            ...(json?.customerListIds || []),
            ...(json?.employeeListIds || []),
          ];
          this.campaignSegments[key].forEach((element) => {
            let val = this.customerSegmentAndTiersMap[element];
            if (!val) {
              val = this.customerSegmentAndTiersMap[element]; //fetching tier name from tierId
            }
            segmentIdArray.push(val);
          });
          this.campaignSegments[key] = segmentIdArray;
          this.customerCount[key] = json?.totalCustomerSize
            ? json.totalCustomerSize
            : 0;
          this.isCustomer[key] =
            json?.allCustomer !== undefined ? json?.allCustomer : null;
          this.isLeads[key] =
            json?.allLead !== undefined ? json?.allLead : null;
        }
        this.challengeList = this.array;
        this.tableLoading = false;
        console.log(this.challengeList);
        console.log(this.campaignSegments);
      }
    },(err) => {
      this._snackBar.openSnackBar("Error in fetching challenge list", 2000);
      this.tableLoading = false;
    });
  }

  refreshPaginateddata(event) {
    if (this.size !== event.pageSize) {
      this.clearCampaignList();
    }
    this.page = event.pageIndex + 1;
    this.size = event.pageSize;
    if (
      Object.keys(this.selectedChallengeListPageWise).indexOf(
        this.page.toString()
      ) === -1
    ) {
      this.selectedChallengeListPageWise[this.page] = [];
    }
    console.log(this.selectedChallengeListPageWise);
    if (this.page >= 1) this.getChallengeList(this.filter.label);
  }

  getChallengeListApi(value?) {
    return new Promise((resolve, reject) => {
      this._apiCall.getchallengeListing(this.page, this.size, value).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  clearCampaignList() {
    for (const key in this.selectedChallengeListPageWise) {
      if (this.selectedChallengeListPageWise.hasOwnProperty(key)) {
        this.selectedChallengeListPageWise[key] = [];
      }
    }
  }

  createChallenge() {
    this.challengeService.resetAllData();
    this.router.navigate(["/app/challenges/create-new"]);
  }

  deleteChallenge(id, name) {
    const dialogRef = this.dialog.open(DeleteGameDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "540px",
      data: {
        subject: "Delete Challenge",
        challengeName: name,
        successButtonText: "Delete",
        cancelButtonText: "Cancel",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.deleteChallengeApi(id).then(
        (res) => {
          if (res) {
            this._snackBar.openSnackBar(
              "Challenge Deleted Successfully",
              2000
            );
            this.getChallengeList(this.filter.label);
          }
        },
        (err) => {
          this._snackBar.openSnackBar("Challenge Deletion Failed", 2000);
        }
      );
    });
  }

  onKeySearch(event: any) {
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.data !== " ") $this.getChallengeList($this.filter.label);
    }, 600);
  }

  convertMarkdownToHtml(markdown: string): string {
    return this.global.convertMarkdownToHtml(markdown);
  }

  executeListing() {}

  openFilterDialog() {}

  getChallengeListLength() {}

  editChallenge(id) {
    this.challengeService.resetAllData();
    this.router.navigate(["/app/challenges/view-challenge"], {
      queryParams: {
        challengeId: id,
      },
    });
  }

  getDateFormat(type?) {
    return this.date_format.getDateFormat(type);
  }

  checkChallengeList(event, type, id) {
    if (event) {
      if (type === "single") {
        this.selectedChallengeListPageWise[this.page].push(id);
      } else {
        for (let data in this.challengeList) {
          console.log(data);
          let i = this.selectedChallengeListPageWise[this.page].indexOf(data);
          if (i === -1) {
            this.selectedChallengeListPageWise[this.page].push(data);
          }
        }
      }
    } else {
      if (type === "single") {
        let index = this.selectedChallengeListPageWise[this.page].indexOf(id);
        this.selectedChallengeListPageWise[this.page].splice(index, 1);
      } else {
        this.selectedChallengeListPageWise[this.page] = [];
      }
    }
  }

  checkIfPresent(id) {
    return (
      this.selectedChallengeListPageWise[this.page]?.length > 0 &&
      (this.selectedChallengeListPageWise[this.page].includes(id.toString()) ||
        this.selectedChallengeListPageWise[this.page].includes(id))
    );
  }

  getCreatedByData(data, type) {
    let datajson = JSON.parse(data);
    if (type === "qid") {
      return datajson?.qid;
    } else if (type === "userName") {
      return datajson?.userName;
    } else if (type === "userEmail") {
      return datajson?.userEmail;
    } else if (type === "storeName") {
      return datajson?.storeName ? datajson?.storeName : "-";
    }
  }

  async getCustomerSegmentsAndTiers(): Promise<void> {
    await this._apiCall.getCustomerSegmentsAndTiers().subscribe(
      (response) => {
        let res = response["body"];
        for (let i = 0; i < res.length; i++) {
          this.customerSegmentAndTiers.push({
            id: res[i]["id"],
            name: res[i]["segmentName"],
            isActive: res[i]["isActive"],
            status: false,
            category: res[i]["category"],
          });
          this.customerSegmentAndTiersMap[res[i]["id"]] = res[i]["segmentName"];
          if (res[i].category == "Segment") {
            if (
              this.tokenStorage.getMerchantOnlineStore() === "shopify" ||
              (res[i]["segmentType"] !== "STANDARD" &&
                this.tokenStorage.getMerchantOnlineStore() !== "shopify")
            ) {
              this.segments.push({
                id: res[i]["id"],
                segmentName: res[i]["segmentName"],
                isActive: res[i]["isActive"],
              });
            }
          }
          if (res[i].category == "Tier") {
            this.tiers.push({
              id: res[i]["id"],
              tierName: res[i]["segmentName"],
              isActive: res[i]["isActive"],
            });
          }
          if (res[i].category == "CustomerList") {
            this.customerLists.push({
              id: res[i]["id"],
              customerListName: res[i]["segmentName"],
              isActive: res[i]["isActive"],
            });
          }
        }
        this.getChallengeList(this.filter.label);
      },
      (error) => {}
    );
  }

  getTypeDisplayName(value: string): string {
    const typeMap: Record<string, string> = {
      MILESTONE_BASED_CHALLENGE: "Milestone",
      MILESTONE: "Milestone",
    };

    return typeMap[value] || value; // Return original value if not found
  }

  getDateInTimeZone(timestamp: number, format: 'time' | 'date'): string {
    return timestamp ? this.global.getDateInTimeZone(timestamp, format) : "";
  }

  deleteChallengeApi(id) {
    return new Promise((resolve, reject) => {
      this._apiCall.deleteChallenge(id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }
}
